import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";

export default class BaseAutoPlayButton extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.incativeTintColor = 0xCCCCCC;
        this.state = 1;

        this.buttonMode = true;
        this._enabled = false;

        this.init();
        this.addListeners();
    }

    init() {

    }

    addListeners() {
        GlobalDispatcher.add('autoPlaySettings:activeChanged', this.onAutoPlayActiveChanged, this);
        GlobalDispatcher.add('autoPlaySettings:countChanged', this.onAutoPlayCountChanged, this);
        this.on('pointertap', this.onButtonTap, this);
    }

    onAutoPlayActiveChanged(event) {
        let state = event.params ? 2 : 1;
        if (EntryPoint.GameModel.isFreeSpins || EntryPoint.GameModel.freeBets) {
            state = 1;
        }
        this.changeState(state);
    }

    onAutoPlayCountChanged(event) {
        this.updateCount(event.params);
    }

    onButtonTap() {
        if(EntryPoint.AutoPlaySettings.active) {
            EntryPoint.AutoPlaySettings.active = false;
        } else {
            GlobalDispatcher.dispatch('ui:openAutoPlayPopup');
        }
    }

    changeState(value) {
        this.state = value;
        this.goToFrame(this.state);
        if (this.state === 1) {
            this.interactive = this._enabled;
            this.children.forEach((child)=>{
                child.tint = this._enabled ? 16777215 : this.incativeTintColor;
            });
        } else {
            this.updateCount(EntryPoint.AutoPlaySettings.count);
            this.interactive = true;
            this.children.forEach((child)=>{
                child.tint = 16777215;
            });
        }
    }

    updateCount(value) {
        let valueText = this.getChildByName('valueText');
        if(valueText) {
            valueText.text = value;
        }
    }

    get enabled() {
        return this._enabled;
    }

    set enabled(value) {
        this._enabled = value;
        if (this.state === 1) {
            this.interactive = this._enabled;
            this.children.forEach((child)=>{
                child.tint = this._enabled ? 16777215 : this.incativeTintColor;
            });
        }
    }
}
